"use client";

import React, { useMemo } from "react";
import { IntlProvider } from "react-intl";

export const I18nProvider = ({ children, locale }) => {
  const browserLocale =
    typeof window !== "undefined"
      ? navigator.language || navigator.languages[0]
      : null;
  const [shortLocale] = !!locale ? [locale] : (browserLocale ? browserLocale.split("-") : ["en"]);

  const messages = useMemo(() => {
    switch (shortLocale) {
      case "es":
        const Spanish = require(`@/constants/locale/es.json`)
        return Spanish;
      case "pt":
        const Portuguese = require(`@/constants/locale/pt.json`)
        return Portuguese;
      case "en":
      default:
        const English = require(`@/constants/locale/en.json`);
        return English;
    }
  }, [shortLocale]);

  return (
    <IntlProvider
      key={shortLocale}
      locale={shortLocale}
      messages={messages}
      onError={() => null}
    >
      {children}
    </IntlProvider >
  );
};
